import { Button } from "@/components/ui/button";
import { Check, Clock, ShoppingBag, Calendar, FileText } from "lucide-react";
import heroFood from "@/assets/hero-food.jpg";
import ebookMockup from "@/assets/ebook-mockup.png";
import { sendPixelEvent } from "@/lib/pixelXApp";
import * as Sentry from '@sentry/react';

const HeroB = () => {
  const handleCheckout = async () => {
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'CTA button clicked',
      level: 'info',
      data: {
        component: 'HeroB',
        variant: 'B',
      },
    });
    
    try {
      await sendPixelEvent('AddToCart');
      
      Sentry.addBreadcrumb({
        category: 'navigation',
        message: 'Redirecting to checkout',
        level: 'info',
        data: { url: "https://pxa.receitasem30minutos.com.br/exp/checkout" },
      });
      
      window.location.href = "https://pxa.receitasem30minutos.com.br/exp/checkout";
    } catch (error) {
      Sentry.captureException(error, {
        tags: { action: 'redirect_checkout' },
      });
    }
  };

  const benefits = [
    { icon: Clock, text: "Pronto em até 30 minutos" },
    { icon: ShoppingBag, text: "Ingredientes simples" },
    { icon: Calendar, text: "Lista de compras única" },
    { icon: FileText, text: "30 receitas diferentes" },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-hero">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZjk4MDAiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDE4YzAtMy4zMTQgMi42ODYtNiA2LTZzNiAyLjY4NiA2IDYtMi42ODYgNi02IDYtNi0yLjY4Ni02LTZ6TTAgMThjMC0zLjMxNCAyLjY4Ni02IDYtNnM2IDIuNjg2IDYgNi0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNnoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40"></div>
      
      <div className="container relative py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <div className="space-y-6 animate-fade-in">
            <div className="inline-block rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
              E-book Digital • Acesso Imediato
            </div>
            
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              <span className="text-foreground">Chega de repetir</span>
              <br />
              <span className="bg-gradient-warm bg-clip-text text-transparent">
                arroz e feijão.
              </span>
            </h1>
            
            <p className="text-xl text-muted-foreground leading-relaxed">
              Tenha <strong className="text-foreground">30 almoços diferentes</strong>, saborosos e prontos em até 30 minutos — usando ingredientes simples que você já tem em casa.
            </p>

            <div className="grid grid-cols-2 gap-3 pt-4">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="flex items-center gap-2 text-sm">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10">
                      <Icon className="h-4 w-4 text-primary" />
                    </div>
                    <span className="text-muted-foreground">{benefit.text}</span>
                  </div>
                );
              })}
            </div>

            <div className="pt-4">
              <Button 
                onClick={handleCheckout}
                size="lg"
                className="bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14 px-8"
              >
                Quero meu e-book por R$ 29,90
              </Button>
              <p className="mt-3 text-sm text-muted-foreground">
                ✓ PDF digital • ✓ Lista de compras inclusa • ✓ 30 receitas completas
              </p>
            </div>
          </div>

          <div className="relative animate-fade-in">
            <div className="absolute -inset-4 bg-gradient-warm opacity-20 blur-3xl rounded-full"></div>
            <img 
              src={ebookMockup} 
              alt="Mockup do e-book 30 Receitas Express em tablet e celular"
              className="relative w-full h-auto drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroB;
